import type { StoreRootState } from "..";

const userSelector = (state: StoreRootState) =>
  state.user?.isLoggedIn ? state.user.data : undefined;

export default userSelector;
